import { all, fork } from 'redux-saga/effects'
import { answerSaga, internetSaga, mobileSaga, scenarioSaga, progressSaga, analyticsSaga, stepSaga } from './effects'

export function* rootSaga() {
  yield all([
    fork(scenarioSaga),
    fork(answerSaga),
    fork(mobileSaga),
    fork(internetSaga),
    fork(progressSaga),
    fork(analyticsSaga),
    fork(stepSaga),
  ])
}
